import React from 'react';
import PropTypes from 'prop-types';
import CloseSolid from '@learningblocks/exp-constants/lib/Icons/close-solid';
import {Tooltip} from '@learningblocks/shared-components/';

export function FeedbackIcon({className, showFeedback, isSuccess, feedback}) {
  let feedbackIcon = null;
  if (showFeedback && !isSuccess) {
    feedbackIcon = (
      <Tooltip title={feedback} className={className}>
        <CloseSolid />
      </Tooltip>
    );
  }
  return feedbackIcon;
} 

FeedbackIcon.propTypes = {
  /**
   * className to set of the icon
   */
  className: PropTypes.string,
  /**
   * Boolean to set if feeback should be displayed
   */
  showFeedback: PropTypes.bool,
  /**
   * Boolean to set if feedback success/failure
   */
  isSuccess: PropTypes.bool,
};
